<template>
	<section :class="['block-wrapper graph-wrapper', componentClass, colorMode, {visible: visible, ready: ready}]">
		<div class="row">
			<div class="columns small-12 medium-6" v-for="chart in data.graphs" v-bind:key="chart.id">
				<chart-bar-horizontal 
					v-if="chart.type==='bar' && chart.center_without_grid" 
					:data="chart" 
					:ready="ready" 
					:colorTheme="colorMode"></chart-bar-horizontal>
				<chart-bar 
					v-if="chart.type==='bar' && !chart.center_without_grid" 
					:data="chart" 
					:ready="ready" 
					:oneCol="true" 
					:colorTheme="colorMode"></chart-bar>
				<chart-line 
					v-if="chart.type==='line'" 
					:data="chart" 
					:ready="ready" 
					:oneCol="true" 
					:colorTheme="colorMode"></chart-line>
				<chart-pie 
					v-if="chart.type==='pie'" 
					:data="chart" 
					:ready="ready" 
					:colorTheme="colorMode"></chart-pie>
			</div>
		</div>
	</section>
</template>

<script>
import BaseBlock from './Base'
export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'dark',
			componentClass: 'graph-side-by-side',
		}
	},
	computed: {
		colorMode() {
			if (typeof this.data.theme !== 'undefined' && this.data.theme !== '') return this.data.theme;
			return this.defaultColorMode;
		}
	},
	components: {
		ChartPie: () => import('./graph/Pie'),
		ChartBarHorizontal: () => import('./graph/BarHorizontal'),
		ChartBar: () => import('./graph/Bar'),
		ChartLine: () => import('./graph/Line'),
	}
}
</script>

<style lang="scss">
	@import "../../styles/scss/component/graph-side-by-side";
</style>